import type { SelectedOs } from "@/modules/compute/os/os.ts";
import { imagesByOsNameAtom } from "@/modules/compute/vmImagesQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import type { VmImage, VmImageVersion } from "@warrenio/api-spec/spec.oats.gen";

export interface UseOsImage {
    image?: VmImage;
    version?: VmImageVersion;
}

export function useOsImage({ os_name, os_version }: SelectedOs): UseOsImage {
    const allImages = useSuspenseQueryAtom(imagesByOsNameAtom);

    const image = allImages.get(os_name);
    const version = image?.versions.find((item) => item.os_version === os_version);
    return { image, version };
}
